import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useCompareValuesPerYearPerMonth } from './hooks/useCompareValuesPerYearPerMonth';

export const CompareValuesPerYearPerMonth = () => {
    const { series, subtitles } = useCompareValuesPerYearPerMonth();

    return (
        <SimpleBars
            title={`Evolução do Total do Valor Aprovado do Procedimento e o Valor Produzido (Apresentado)`}
            series={series}
            subtitles={subtitles}
            height={320}
            isMoney
            showDataLabels={false}
        />
    );
};
